// extracted by mini-css-extract-plugin
module.exports = {"container":"SwipeCarousel_container__2ZmXu","carouselGroup":"SwipeCarousel_carouselGroup__2aPek","carouselItems":"SwipeCarousel_carouselItems__2TJh9"};